<self-filer-section
  [header]="'ON_BOARDING.ABI_PROFILE'"
  [description]="
    ('ON_BOARDING.ABI_PROFILE_DESC' | translate) +
    (hasFilerCode ? '' : '<br/>' + ('ON_BOARDING.ABI_PROFILE_CARD.UPDATE_MESSAGE' | translate))
  "
>
  <card-default [description]="'ON_BOARDING.ABI_PROFILE_CARD.TEXT_NO'" [sticky]="true">
    <button
      card-footer
      type="button"
      class="btn btn-primary"
      [routerLink]="['/on-boarding', 'abi-profile-request']"
      [queryParams]="{ returnUrl: currentUrl }"
      [disabled]="!hasFilerCode"
    >
      {{ "ON_BOARDING.SEND_REQUEST_FOR_ABI" | translate }}
    </button>
  </card-default>
  <card-default [description]="!isSuccess ? 'ON_BOARDING.ABI_PROFILE_ENTER_ABI_DETAILS' : ''" [sticky]="false">
    <div header-action class="d-flex justify-content-end">
      <!--      <button *ngIf="isSuccess && !isOpenForm" (click)="openForm()" class="edit-toggle">-->
      <!--        <i class="fa fa-pencil"></i>-->
      <!--      </button>-->
      <dropdown-action *ngIf="isSuccess" [iconColor]="iconColor" [menuMode]="menuMode" [id]="'abi-profile-actions'" className="m-1">
        <button dropdown-item *ngIf="!isOpenForm" class="dropdown-item" (click)="openForm()">
          {{ "BUTTON.EDIT" | translate }}
        </button>
        <button dropdown-item class="dropdown-item" (click)="clearAndSave()">
          {{ "BUTTON.DELETE" | translate }}
        </button>
      </dropdown-action>
    </div>

    <div *ngIf="isSuccess && !isOpenForm">
      <div class="mt-0">
        <self-filer-field-view [label]="'LABELS.NAME'">{{ abiProfileDetails?.abiRepresentative?.name }}</self-filer-field-view>
      </div>
      <div class="mt-2">
        <self-filer-field-view [label]="'LABELS.EMAIL_ADDRESS'">{{ abiProfileDetails?.abiRepresentative?.email }}</self-filer-field-view>
      </div>
      <div class="mt-2">
        <self-filer-field-view [label]="'LABELS.FAX'">{{ abiProfileDetails?.abiRepresentative?.fax }}</self-filer-field-view>
      </div>
      <div class="mt-2">
        <self-filer-field-view [label]="'LABELS.MOBILE_NUMBER'">{{ abiProfileDetails?.abiRepresentative?.phone }}</self-filer-field-view>
      </div>
      <div class="mt-2">
        <self-filer-field-view [label]="'LABELS.ADDRESS'">
          <address-details
            *ngIf="abiProfileDetails?.abiRepresentative?.address"
            [address]="abiProfileDetails?.abiRepresentative?.address"
          ></address-details>
        </self-filer-field-view>
      </div>
    </div>
    <self-filer-abi-client-representative-form
      [entity]="abiProfileDetails?.abiRepresentative"
      *ngIf="isOpenForm"
    ></self-filer-abi-client-representative-form>
    <button
      card-footer
      *ngIf="!isSuccess && !isOpenForm"
      type="button"
      class="btn btn-primary"
      (click)="openForm()"
      [disabled]="!hasFilerCode"
    >
      {{ "ON_BOARDING.I_HAVE_ABI_CLIENT_REPRESENTATIVE" | translate }}
    </button>
    <button card-footer *ngIf="isOpenForm" type="button" class="btn btn-primary" (click)="save()" [disabled]="formComponent?.fg?.invalid">
      {{ "BUTTON.SAVE" | translate }}
    </button>
    <button card-footer *ngIf="isOpenForm" type="button" class="btn btn-secondary" (click)="isOpenForm = false">
      {{ "BUTTON.CANCEL" | translate }}
    </button>
  </card-default>
</self-filer-section>
